var _circle, _circle2, _circle3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 574,
    height: 574,
    viewBox: "0 0 574 574",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 287,
    cy: 287,
    r: 241,
    stroke: "#59C3FF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 287,
    cy: 287,
    r: 174,
    stroke: "#59C3FF",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 287,
    cy: 287,
    r: 286,
    stroke: "#59C3FF",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8695_1108)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 141.5,
    cy: 97.5,
    r: 25.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8695_1108)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 491.5,
    cy: 86.5,
    r: 25.5,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8695_1108)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 429.5,
    cy: 389.5,
    r: 25.5,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8695_1108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.102 87.4813L502.134 94.9859C502.138 96.65 500.843 98 499.245 98H484.782C483.187 98 481.893 96.6547 481.893 95V87.4813H480.447C479.633 87.4813 479 86.8203 479 85.9766C479 85.5547 479.136 85.1797 479.452 84.8516L491.025 74.3757C491.341 74.047 491.702 74 492.018 74C492.334 74 492.695 74.0939 492.97 74.3288L497.778 78.7203V77C497.778 76.1717 498.423 75.5 499.222 75.5H500.667C501.466 75.5 502.111 76.1717 502.111 77V82.6719L504.494 84.8516C504.856 85.1797 505.041 85.5547 504.991 85.9766C504.991 86.8203 504.314 87.4813 503.547 87.4813H502.102ZM497.056 85.625C497.056 85.2125 496.731 84.875 496.333 84.875H493.806V82.25C493.806 81.8375 493.481 81.5 493.083 81.5H490.917C490.519 81.5 490.194 81.8375 490.194 82.25V84.875H487.667C487.269 84.875 486.944 85.2125 486.944 85.625V87.875C486.944 88.2875 487.269 88.625 487.667 88.625H490.194V91.25C490.194 91.6625 490.519 92 490.917 92H493.083C493.481 92 493.806 91.6625 493.806 91.25V88.625H496.333C496.731 88.625 497.056 88.2875 497.056 87.875V85.625Z",
    fill: "#014971"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8695_1108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.05 392.677V392.75H420.121C420.097 392.724 420.074 392.703 420.05 392.677ZM423.425 392.75C425.287 392.75 426.8 391.208 426.8 389.351C426.8 387.494 425.286 385.952 423.425 385.952C421.564 385.952 420.05 387.418 420.05 389.312C420.05 391.207 421.565 392.75 423.425 392.75ZM426.8 392.677C426.775 392.703 426.754 392.724 426.728 392.75H426.8V392.677ZM438.95 385.875H435.486L435.014 386.902C434.626 387.731 433.795 388.273 432.875 388.281C431.979 388.281 431.147 387.752 430.753 386.934L430.243 385.875H428.825C428.452 385.875 428.15 386.183 428.15 386.524V394.048L418.7 394.125V382.438C418.7 382.058 418.398 381.789 418.025 381.789H416.675C416.302 381.789 416 382.097 416 382.438V400.312C416 400.691 416.302 401 416.675 401H418.025C418.398 401 418.7 400.691 418.7 400.312V398.289H440.3V400.312C440.3 400.692 440.602 401 440.975 401H442.325C442.698 401 443 400.692 443 400.312V390C443 387.684 441.186 385.875 438.95 385.875ZM442.325 381.063H437.465L436.415 379.46C436.317 379.31 436.182 379.196 436.029 379.117C435.98 379.091 435.924 379.093 435.871 379.076C435.777 379.044 435.68 379 435.579 379C435.553 379 435.526 379.001 435.5 379.003C435.136 379.031 434.815 379.256 434.659 379.592L432.857 383.494L431.966 381.641C431.796 381.288 431.443 381.064 431.057 381.064L424.775 381.063C424.404 381.063 424.1 381.371 424.1 381.751V382.438C424.1 382.818 424.402 383.087 424.737 383.125L430.352 383.126L431.89 386.329C432.137 386.683 432.487 386.906 432.875 386.906C433.264 386.903 433.625 386.673 433.791 386.314L435.728 382.124L436.083 382.666C436.271 382.914 436.55 383.125 436.925 383.125H442.325C442.698 383.125 443 382.818 443 382.438V381.75C443 381.371 442.696 381.063 442.325 381.063Z",
    fill: "#014971"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_8695_1108)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 380.5,
    r: 25.5,
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8695_1108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0002 373.813C74.1593 373.813 72.6668 375.352 72.6668 377.25C72.6668 378.661 73.4922 379.87 74.6714 380.4V383.782C74.6714 386.242 72.5777 388.251 70.0047 388.251C67.5047 388.251 65.4506 386.356 65.3422 383.987C68.3377 383.343 70.6668 380.572 70.6668 377.211V370.572C70.6668 370.083 70.3272 369.654 69.8635 369.563L67.2418 369.021C66.7002 368.908 66.1777 369.268 66.0685 369.827L65.9335 370.504C65.8241 371.062 66.1757 371.603 66.7172 371.716L67.996 371.977V377.194C67.996 379.466 66.2406 381.346 64.0322 381.368C61.8081 381.389 59.9985 379.539 59.9985 377.246L59.9956 371.981L61.2756 371.718C61.8172 371.611 62.1677 371.067 62.0581 370.509L61.9293 369.832C61.8252 369.274 61.2981 368.912 60.7564 369.025L58.1368 369.558C57.6731 369.655 57.3335 370.078 57.3335 370.572V377.25C57.3335 380.569 59.6297 383.351 62.671 383.987C62.7793 387.876 66.0252 391 70.0002 391C74.0418 391 77.3335 387.762 77.3335 383.781V380.4C78.5097 379.869 79.3335 378.661 79.3335 377.252C79.3335 375.351 77.8418 373.813 76.0002 373.813ZM76.0002 378.281C75.4481 378.281 75.0002 377.819 75.0002 377.25C75.0002 376.681 75.446 376.219 76.0002 376.219C76.5543 376.219 77.0002 376.679 77.0002 377.25C77.0002 377.822 76.5543 378.281 76.0002 378.281Z",
    fill: "#014971"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_8695_1108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.667 87.375C133.088 87.375 131 89.5286 131 92.1488V101.735C131 104.394 133.088 106.509 135.667 106.509C138.245 106.509 140.333 104.355 140.333 101.735V92.1488C140.333 89.5286 138.246 87.375 135.667 87.375ZM137.667 97H133.667V92.1875C133.667 91.0488 134.563 90.125 135.667 90.125C136.771 90.125 137.667 91.0488 137.667 92.1875V97ZM143.492 95.7195C143.346 95.5691 143.096 95.5906 142.976 95.7571C141.09 98.4427 141.293 102.207 143.637 104.626C145.987 107.043 149.638 107.258 152.242 105.308C152.408 105.185 152.419 104.932 152.273 104.782L143.492 95.7195ZM153.063 94.9031C150.719 92.4861 147.067 92.2764 144.463 94.2212C144.296 94.3447 144.28 94.6026 144.426 94.7532L153.214 103.807C153.359 103.957 153.604 103.941 153.724 103.774C155.617 101.086 155.413 97.3266 153.063 94.9031Z",
    fill: "#014971"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8695_1108",
    x: 95,
    y: 55,
    width: 93,
    height: 93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8695_1108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8695_1108",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8695_1108",
    x: 445,
    y: 44,
    width: 93,
    height: 93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8695_1108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8695_1108",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8695_1108",
    x: 383,
    y: 347,
    width: 93,
    height: 93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8695_1108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8695_1108",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_8695_1108",
    x: 22,
    y: 338,
    width: 93,
    height: 93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8695_1108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8695_1108",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8695_1108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 24,
    fill: "white",
    transform: "translate(479 74)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8695_1108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 22,
    fill: "white",
    transform: "translate(416 379)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8695_1108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    fill: "white",
    transform: "translate(56 369)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_8695_1108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    fill: "white",
    transform: "translate(131 86)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFrame);
export default __webpack_public_path__ + "static/media/home-frame.d025589f7c5ae0f3d653ba36eab34116.svg";
export { ForwardRef as ReactComponent };